import React from "react";
import { programsData } from "../../data/programsData";
import "./Programs.css";
import RightArrow from "../../assets/rightArrow.png";

const Programs = () => {
  console.log(programsData, "programsData");
  return (
    <div className="programs" id="Programs">
      {/* header */}
      <div className="programs-header">
        <span className="stroke-text">Explore Our</span>
        <span>Programs</span>
        <span className="stroke-text">to shape you</span>
      </div>

      <div className="programs-categories">
        {programsData.map((program) => (
          <div className="category" key={"heading"}>
            {program.image}
            <span>{program.heading}</span>
            <span>{program.details}</span>
            <div className="join-now">
              <span>Join Now</span>
              <img src={RightArrow} alt="" />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Programs;
